import React from "react";
import PolicyLayout from "../../../components/PolicyLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function AccountRemovePage() {
  return (
    <PolicyLayout title="account removal" appName="Seek AI Chat" date="MARCH 2026">
      <p>
        This page describes how users of the mobile application Seek AI Chat can
        request deletion of their account and related personal data. The
        application is published by goodwavelab as the developer.
      </p>

      <div className={s.title}>1) How to request account deletion</div>
      <p>
        To delete your Seek AI Chat account and the data stored on our side,
        please follow these steps:
      </p>
      <ul>
        <li>
          Send an email to account@goodwavelab.com with the subject line:
          "Seek AI Chat - Account deletion request".
        </li>
        <li>
          In the email, include your full name or nickname used in the app.
        </li>
        <li>Include the email address linked to your account.</li>
        <li>Include your device platform (Android or iOS).</li>
        <li>
          Confirm that you want your account and related data to be deleted.
        </li>
      </ul>
      <p>
        Optionally, you can also contact us from inside the app by going to:
        Profile - Support - Contact us and sending the same request text.
      </p>
      <p>
        After receiving your request, we will confirm your identity if needed
        and start the deletion process.
      </p>

      <div className={s.title}>2) What data will be deleted</div>
      <p>
        When we process an account deletion request for Seek AI Chat, we delete
        or permanently anonymize the following types of data that we control:
      </p>
      <ul>
        <li>
          Account profile data stored in the app backend (nickname, internal
          user ID, language preferences).
        </li>
        <li>
          Activity history in the app interface (in-app actions, mission
          progress, bonus views).
        </li>
        <li>
          In-app support messages sent through the Seek AI Chat support section.
        </li>
        <li>
          Technical identifiers linked to your account that are used only inside
          this app.
        </li>
      </ul>
      <p>
        After deletion is completed, this information will no longer be linked
        to you as an identifiable user.
      </p>

      <div className={s.title}>3) Data that may be retained and retention periods</div>
      <p>
        Some data may still be retained for a limited period of time for legal,
        security or technical reasons. This data is not used for marketing
        purposes.
      </p>
      <p>
        <strong>Server logs and security records.</strong> These may include IP
        address, device information and error logs. Retention period: up to 12
        months for security, fraud prevention and abuse monitoring.
      </p>
      <p>
        <strong>Legal and accounting records.</strong> If required by applicable
        law, we may keep minimal records that prove that we processed a deletion
        request or other user actions. Retention period: up to 36 months or
        longer if required by law.
      </p>
      <p>
        <strong>Aggregated or anonymized analytics.</strong> We may keep
        anonymized statistics that can no longer be connected to a specific
        user. These do not contain personal data.
      </p>

      <div className={s.title}>4) Processing time</div>
      <p>
        We aim to process account deletion requests within 30 days from the
        moment we receive all necessary information to verify your identity. In
        many cases this will happen faster.
      </p>

      <div className={s.title}>5) Contact</div>
      <p>
        If you have any questions about this policy or about your data, you can
        contact us at: account@goodwavelab.com
      </p>
    </PolicyLayout>
  );
}